import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './component/Home/Home';
import Footer from './component/Shared/Footer/Footer';
import TakedownPolicy from './component/Shared/Footer/legal/TakedownPolicy';
import TermsAndConditions from './component/Shared/Footer/legal/TermsAndConditions';
import Refund from './component/Shared/Footer/legal/Refund';
import Cookie from './component/Shared/Footer/legal/Cookie';
import Privacy from './component/Shared/Footer/legal/Privacy';
import Header from './component/Shared/Header';
import NotFound from './component/Shared/NotFound';
import AboutUs from './component/AboutUs/AboutUs';
import Counselor from './component/BecomeACounselor/Counselor';
import ContactUs from './component/ContactUs/ContactUs';
import Blog from './component/Blog/Blog';
import OurCourses from './component/OurCourses/OurCourses';
import DigitalMarketing from './component/OurCourses/AllCourses/DigitalMarketing';
import WebDevelopment from './component/OurCourses/AllCourses/WebDevelopment';
import DataScience from './component/OurCourses/AllCourses/DataScience';
import GraphicsDesigning from './component/OurCourses/AllCourses/GraphicsDesigning';
import Blockchain from './component/OurCourses/AllCourses/Blockchain';
import FullStack from './component/OurCourses/AllCourses/FullStack';
import InternetThings from './component/OurCourses/AllCourses/InternetThings';
import MachineLearning from './component/OurCourses/AllCourses/MachineLearning';
import Gsoc from './component/OurCourses/AllCourses/Gsoc';
import CloudComputing from './component/OurCourses/AllCourses/CloudComputing';
import ArVr from './component/OurCourses/AllCourses/ArVr';
import AndroidDevelopment from './component/OurCourses/AllCourses/AndroidDevelopment';
import CourseMenu from './component/Shared/CourseMenu';

function App() {
  return (
    <div >
      <Header />
      <CourseMenu />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/about-us' element={<AboutUs />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/career' element={<Counselor />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/courses' element={<OurCourses />} />

        <Route path='/digital-marketing' element={<DigitalMarketing />} />
        <Route path='/web-development' element={<WebDevelopment />} />
        <Route path='/data-science' element={<DataScience />} />
        <Route path='/graphics-designing' element={<GraphicsDesigning />} />
        <Route path='/blockchain' element={<Blockchain />} />
        <Route path='/full-stack-web-development' element={<FullStack />} />
        <Route path='/internet-things' element={<InternetThings />} />
        <Route path='/machine-learning' element={<MachineLearning />} />
        <Route path='/GSOC' element={<Gsoc />} />
        <Route path='/cloud-computing' element={<CloudComputing />} />
        <Route path='/ar-vr-mr' element={<ArVr />} />
        <Route path='/android-app-development' element={<AndroidDevelopment />} />

        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='/takedown-policy' element={<TakedownPolicy />} />
        <Route path='/refund-policy' element={<Refund />} />
        <Route path='/cookie-policy' element={<Cookie />} />
        <Route path='/privacy-policy' element={<Privacy />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;